<div style="position: relative;">
  <img  src="../../../assets/images/VisionMWS.ico" (click)="setting()"
      style="width: 20px;cursor: pointer;background: white;border: 1px solid;border-radius: 5px;" />
  <!-- <mat-icon class="tool-icon" title="除錯輔助工具" (click)="setting()">
      build
  </mat-icon> -->
</div>
